import axios from "axios";
import { message } from "antd";
import { attachAuthRefresh } from "../../../apis/tokenRefresh";

const BASE_URL = process.env.REACT_APP_API_URL || "https://api-dev2.materialdepot.in/apiV1";

const client = axios.create({ baseURL: BASE_URL });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});

attachAuthRefresh(client);

// const localClient = axios.create({ baseURL: LOCAL_BASE_URL });

// localClient.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `JWT ${token}`;
//   }
//   return config;
// });

export const getDeliveries = async (params: any) => {
  try {
    const response = await client.get("/po-deliveries-v2/", { params });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getDeliveryInfoByPoNumber = async (po_number: string) => {
  try {
    const response = await client.get("/po-deliveries-v2/", {
      params: { po_number },
    });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getDeliveryInfoByLeadId = async (lead_id: string) => {
  try {
    const response = await client.get("/po-deliveries-v2/", {
      params: { lead_id },
    });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const updatePoDeliveryLegStatus = async (po_delivery_id: number, leg_status: string, remark?: string) => {
  try {
    const response = await client.put("/update-po-delivery-leg-status-v2/", { po_delivery_id, leg_status, remark });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const editDelivery = async (data: any) => {
  try {
    const response = await client.put("/po-deliveries-v2/", data);
    return response.data;
  } catch (e) {
    return null;
  }
};

export const listPOF = async (po_delivery_id: number) => {
  try {
    const response = await client.get("/list-pof/", { params: { po_delivery_id } });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const deletePOF = async (proof_id: number) => {
  try {
    const response = await client.delete("/delete-pof/", { data: { proof_id } });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const importLoginextTrip = async (tripNames: string[]) => {
  try {
    const response = await client.post("/import-loginext-trips/", { trip_names: tripNames });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const importLoginextTripsMultileg = async (tripNames: string[]) => {
  try {
    const response = await client.post("/import-loginext-trips-multileg/", { trip_names: tripNames });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const pushTripToPidgeWithName = async (tripName: string) => {
  try {
    const response = await client.get("/push-to-pidge-from-trip/", { params: { trip_name: tripName } });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const editPurchaseOrder = async (po_id: any, params: any, qParams = {}) => {
  try {
    const res = await client.put(`/po/${po_id}/`, params, { params: { ...qParams } });
    message.success("PO edited succesfully");
    return res?.data;
  } catch (error: any) {
    message.error("Error editing PO. Please try again.");
    return false;
  }
};

export const assigneVehicleNumberToTrip = async ({
  trip_name,
  vehicle_number,
}: {
  trip_name: string;
  vehicle_number: string;
}) => {
  try {
    const res = await client.post("/assign-vehicle-number-to-trip/", { trip_name, vehicle_number });
    return res?.data;
  } catch (error) {
    return null;
  }
};

export const assignVehicleNumberToTripV2 = async ({
  trip_name,
  vehicle_number,
}: {
  trip_name: string;
  vehicle_number: string;
}) => {
  const res = await client.post("/assign-vehicle-number-to-trip-v2/", { trip_name, vehicle_number });
  return res?.data;
};

export const exportPOCSV = async (params: any) => {
  try {
    const res = await client.get("/po-export-csv/", { params });
    return res?.data;
  } catch (error) {
    message.error("Error exporting PO data. Please try again.");
    return null;
  }
};

export const createLoginextOrders = async (start_date?: string, end_date?: string) => {
  try {
    message.loading({ content: "Creating orders in LogiNext", key: "createLoginextOrders" });
    const res = await client.get("/create-loginext-orders/", { params: { start_date, end_date } });
    message.success({ content: "Pushed POs to LogiNext successfully", key: "createLoginextOrders" });
    return res?.data;
  } catch (error) {
    message.error({ content: "Error creating orders. Please try again.", key: "createLoginextOrders" });
    return null;
  }
};

export const fetchBranchMembers = async (params?: any) => {
  try {
    const res = await client.get("/user-organisation/", { params });
    return res?.data ?? [];
  } catch (error) {
    return [];
  }
};

export const fetchUserDetails = async () => {
  try {
    const res = await client.get("/procurement-current-user/");
    return res.data;
  } catch (error) {
    return null;
  }
};

export const raiseDeliveryEscalation = async (data: {
  po_delivery_id: number;
  issue_type: string;
  remarks?: string;
  accountability?: string;
}) => {
  try {
    const response = await client.post("/raise-delivery-escalation/", data);
    message.success("Escalation raised successfully");
    return response.data;
  } catch (e) {
    message.error("Failed to raise escalation");
    return null;
  }
};

export const fetchVendors = async (params: any) => {
  try {
    const res = await client.get("/vendor/", { params });
    return res.data;
  } catch (error) {
    return null;
  }
};
